interface HighlightedTextProps {
  /** The full text to render. */
  text: string;
  /** The search query whose first case-insensitive match gets tinted. */
  query?: string;
}

/**
 * Renders text with the first case-insensitive occurrence of the query tinted.
 * Matching is done by index lookup rather than a regex so queries containing
 * regex metacharacters are matched literally instead of throwing.
 * @param props - The text to render and the query to highlight within it
 * @returns The text with the matched span wrapped in a tinted element
 */
export function HighlightedText({ text, query }: HighlightedTextProps) {
  const trimmedQuery = query?.trim() ?? "";
  if (!trimmedQuery) {
    return <>{text}</>;
  }

  const matchStart = text.toLowerCase().indexOf(trimmedQuery.toLowerCase());
  if (matchStart === -1) {
    return <>{text}</>;
  }

  const matchEnd = matchStart + trimmedQuery.length;
  return (
    <>
      {text.slice(0, matchStart)}
      <span className="rounded-[2px] bg-primary/20 text-foreground">
        {text.slice(matchStart, matchEnd)}
      </span>
      {text.slice(matchEnd)}
    </>
  );
}
